// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bc{color:#1fc0ff}.sector_bc{background:linear-gradient(#1fc0ff,#b381ff)}.evnt{color:#f87f95}.sector_evnt{background:linear-gradient(#f87f95,#f89b78)}.loyalty{color:#ef9f73}.sector_loyalty{background:linear-gradient(#ef9f73,#efc873)}.lib{color:#279f79}.sector_lib{background:linear-gradient(#279f79,#279f79)}.pas{color:#a35cfa}.sector_pas{background:linear-gradient(#a35cfa,#df6bfe)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
